var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 45,
    viewBox: "0 0 143 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M142.119 34.9261C142.119 34.9261 119.744 30.8734 95.454 40.9705C71.1654 51.0668 46.9956 37.9632 46.9956 37.9632C46.9956 37.9632 75.0247 40.738 89.7647 30.8519C89.7647 30.8519 55.3142 37.993 42.2721 31.943C29.2299 25.8929 12.4986 7.4187 0.0870972 13.7385C0.0870972 13.7385 46.84 -7.18732 71.1613 7.6942C71.1613 7.6942 66.3008 2.52809 62.0312 1.83845C62.0312 1.83845 84.223 -4.16275 106.38 12.069C124.793 25.5566 132.883 24.8474 142.119 34.9261Z",
    fill: "url(#paint0_linear_74_244)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_74_244",
    x1: 0.541525,
    y1: 10.9251,
    x2: 142.297,
    y2: 33.8215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA8330"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#F15A29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9225,
    stopColor: "#EF3C25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED1C24"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/Fire.605bd8c78f29055281363695c2703e3a.svg";
export { ForwardRef as ReactComponent };